import Vue from 'vue'
import Router from 'vue-router'

const getComponent = page => () => import(`../model/${page}`)

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/wallet'
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: getComponent('wallet/wallet')
    },
    {
      path: '/wallet/recharge',
      name: 'recharge',
      component: getComponent('wallet/recharge')
    },
    {
      path: '/wallet/takeMoney',
      name: 'takeMoney',
      component: getComponent('wallet/takeMoney')
    },
    {
      path: '/personal',
      name: 'personal',
      component: getComponent('personal/personal')
    },
    {
      path: '/bill',
      name: 'bill',
      component: getComponent('bill/bill')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/pages/personal/router/index.js